import { render, staticRenderFns } from "./DataSort.vue?vue&type=template&id=06c0619c&scoped=true&"
import script from "./DataSort.vue?vue&type=script&lang=js&"
export * from "./DataSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0619c",
  null
  
)

export default component.exports